import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)

    return Object.freeze({
        showForm, setShowForm
    })
}